<template>
  <div>
    <div v-if="edit">
      <v-row no-gutters>
        <v-form
          ref="refForm"
          v-model="valid"
          lazy-validation
          style="width: 100%"
          @submit.prevent
        >
          <v-text-field
            class="textField"
            ref="name"
            v-if="edit && type === 'text'"
            v-model="text"
            @keyup.enter="$emit('update')"
            @keydown.enter="onTextFieldEnter"
            autofocus
            filled
            dense
            :rules="[rules.required]"
            required
            clearable
            @input="onChangeText"
            :disabled="!updateMeetingPermission"
            @blur="onSaveTextFieldValue"
            :key="locale"
            :placeholder="$t('agenda.lblMeetingLocation')"
            :maxLength="maxLength"
          >
          </v-text-field>
          <v-select
            class="selectField"
            v-else-if="edit && type === 'select'"
            @keydown.enter.prevent
            v-model="text"
            :items="resolutionType"
            filled
            dense
            autofocus
            :menu-props="{ bottom: true, offsetY: true }"
            @change="onChangeText"
            item-color="darkCharcoal"
            @blur="onSaveTextFieldValue"
            item-text="label"
            item-value="value"
          ></v-select>
          <v-text-field
            :key="locale"
            class="textField"
            ref="name"
            v-else-if="edit && type === 'meetingLink'"
            v-model="text"
            @keyup.enter="$emit('update')"
            @keydown.enter="onTextFieldEnter"
            autofocus
            :placeholder="$t('agenda.lblMeetingLink')"
            filled
            dense
            :rules="[rules.meetingLinkRule]"
            clearable
            @input="onChangeText"
            :disabled="!updateMeetingPermission"
            @blur="onSaveTextFieldValue"
            :maxLength="maxLength"
          >
          </v-text-field>
          <v-text-field
            class="textField"
            ref="name"
            v-else-if="edit && type === 'meetingTheme'"
            v-model="text"
            @keydown.enter="onTextFieldEnter"
            @keyup.enter="$emit('update')"
            @keydown.enter.prevent
            autofocus
            filled
            dense
            clearable
            :counter="350"
            :maxlength="350"
            :placeholder="$t('agenda.lblMeetingTheme')"
            @input="onChangeText"
            :disabled="!updateMeetingPermission"
            @blur="onSaveTextFieldValue"
          >
          </v-text-field>
        </v-form>
      </v-row>
      <v-row no-gutters v-if="false">
        <v-col cols="12" sm="12" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                x-small
                color="primaryDark"
                width="24"
                min-width="24"
                @click.prevent="onSaveTextFieldValue"
              >
                <v-icon size="16" color="#ffffff"> mdi-check</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("btnSave") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                x-small
                color="secondary"
                width="24"
                min-width="24"
                @click.prevent="onBlur"
              >
                <v-icon size="16" color="neutralGray1"> mdi-close</v-icon>
              </a-btn>
            </template>
            <span>{{ $t("btnClose") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div v-if="type === 'meetingTheme' || type === 'meetingLink'">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              :style="
                type === 'meetingTheme'
                  ? 'display: inline-block; min-width: 105px; word-break: break-word;'
                  : ''
              "
              v-if="type !== 'meetingLink'"
              v-bind="attrs"
              v-on="on"
              class="label-m"
              ><v-icon
                size="18"
                color="darkCharcoal"
                class="mr-2"
                >{{ icon }}</v-icon
              >
              <span v-if="text">{{ getData(text) }}</span>
              <span v-else style="color: #b4b4b4">
                {{
                  type === "meetingTheme"
                    ? $t("agenda.lblMeetingTheme")
                    : $t("agenda.lblMeetingLocation")
                }}
              </span>
              <!-- {{ text || "Meeting theme not added" }} -->
            </span>
            <span v-else class="label-m" v-bind="attrs" v-on="on"
              ><v-icon left size="18" color="#333333">mdi-link</v-icon>
              <a v-if="text" :href="text" target="_blank">{{ text }}</a>
              <span v-else style="color: #b4b4b4">
                {{ $t("agenda.lblMeetingLink") }}
              </span>
            </span>
          </template>
          <span>{{ lable }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="updateMeetingPermission && isEditable">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="ml-2"
              x-small
              color="secondary"
              width="24"
              min-width="24"
              v-bind="attrs"
              v-on="on"
              @click="onEdit"
            >
              <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
            </a-btn>
          </template>
          <span>{{ getEditIconText() }}</span>
        </v-tooltip>
      </div>
      <v-row no-gutters v-else>
        <v-col cols="2" class="field-icon-col">
          <v-icon
            size="18"
            color="darkCharcoal"
            class=""
            >{{ icon }}</v-icon
          >
        </v-col>
        <v-col style="max-width: fit-content;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                :style="
                  type === 'meetingTheme'
                    ? 'display: inline-block; min-width: 105px;'
                    : ''
                "
                v-if="type !== 'meetingLink'"
                v-bind="attrs"
                v-on="on"
                class="label-m mr-5"
                >
                <span v-if="text">{{ getData(text) }}</span>
                <span v-else style="color: #b4b4b4">
                  {{
                    type === "meetingTheme"
                      ? $t("agenda.lblMeetingTheme")
                      : $t("agenda.lblMeetingLocation")
                  }}
                </span>
                <!-- {{ text || "Meeting theme not added" }} -->
              </span>
              <span v-else class="label-m" v-bind="attrs" v-on="on"
                ><v-icon left size="18" color="#333333">mdi-link</v-icon>
                <a v-if="text" :href="text" target="_blank">{{ text }}</a>
                <span v-else style="color: #b4b4b4">
                  {{ $t("agenda.lblMeetingLink") }}
                </span>
              </span>
            </template>
            <span>{{ lable }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="2" v-if="updateMeetingPermission && isEditable">
          <v-tooltip bottom v-if="updateMeetingPermission && isEditable">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class=""
                x-small
                color="secondary"
                width="24"
                min-width="24"
                v-bind="attrs"
                v-on="on"
                @click="onEdit"
              >
                <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
              </a-btn>
            </template>
            <span>{{ getEditIconText() }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isURL } from "../utils/util";
import { DESCRIPTION_LENGTH_10000 } from "@/utils/constant";

export default {
  name: "InPlaceTextFieldEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "text",
    },
    icon: String,
    lable: "",
    field: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: DESCRIPTION_LENGTH_10000,
    },
  },
  data() {
    return {
      valid: true,
      edit: false,
      rules: {
        required: (value) =>
          !!(value ? value.trim() : "") || this.$t("agenda.ruleLocationReq"),
        meetingLinkRule: (value) =>
          isURL(value ? value.trim() : "") || this.$t("agenda.validUrl"),
      },
      previousText: "",
    };
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
      resolutionType: "meeting/getResolutionTypesList",
    }),
    locale() {
      return this.$i18n.locale;
    },
    text: {
      get() {
        // this.previousText = this.previousText || this.value.trim();
        let value = this.value ? this.value.trim() : "";
        if (this.field == "resolutionType") {
          value = value
            ? value.toLowerCase().replace(/\b./g, function (a) {
                return a.toUpperCase();
              })
            : "";
        }
        if (value) {
          return value;
        }
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
  },
  methods: {
    getData(text) {
      if(text) {
        if(this.field == "resolutionType") {
          let resType = this.resolutionType.filter((obj) => obj.value === text);
          return resType.length > 0 ? resType[0].label : text;
        }
        else {
          return text;
        }
      }  
    },
    onTextFieldEnter() {
      if (!this.$refs.refForm.validate()) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
    getEditIconText() {
      switch (this.lable) {
        case this.$t("agenda.lblResType"):
          return this.$t("agenda.tipUpdateResType");
        case this.$t("agenda.lblMeetingLocation"):
          return this.$t("agenda.tipUpdateLocation");
        case this.$t("agenda.lblMeetingTheme"):
          return this.$t("agenda.tipUpdateMeetingTheme");
        case this.$t("agenda.lblMeetingLink"):
          return this.$t("agenda.tipUpdateMeetingLink");
        default:
          return this.$t("btnEdit");
      }
    },
    onSaveTextFieldValue() {
      if (this.$refs.refForm.validate()) {
        if (this.text) {
          this.edit = false;
        } else if (
          !this.text &&
          (this.type === "meetingLink" || this.type === "meetingTheme")
        ) {
          this.edit = false;
        }
        // this.$refs["name"].validate(true);
      }
    },
    onBlur() {
      this.text = this.previousText;
      this.edit = false;
    },
    onChangeText() {
      this.$eventHub.$emit("onMeetingUpdate");
    },
    onEdit() {
      this.edit = true;
      this.previousText = this.text;
    },
  },
};
</script>

<style scoped>
.v-text-field.v-text-field--enclosed /deep/ .v-text-field__details {
  margin-bottom: 0px !important;
}
.v-text-field input {
  line-height: 0px !important;
}
.textField /deep/ input,
.selectField /deep/ .v-select__selection {
  line-height: 21px !important;
}
@media (min-width: 1705px) and (max-width: 1819px) {
  .field-icon-col.col-2 {
    flex: 0 0 16.6666666667%;
    max-width: 10.666667%;
  }
}
@media (min-width: 1820px) and (max-width: 2048px) {
  .field-icon-col.col-2 {
    flex: 0 0 16.6666666667%;
    max-width: 10.666667%;
  }
}
@media (min-width: 2049px) and (max-width: 2735px) {
  .field-icon-col.col-2 {
    flex: 0 0 16.6666666667%;
    max-width: 10.666667%;
  }
}
</style>